<div class="row mt-2">
  <div class="col-md-12 fnt-size14px" (click)="navigateto()"
    [eventTracker]='{"category":"web_share","action":"click_on_drug_detail","product_type":product_type,"product_id":product_type_id}'>
    <div class="bg-white rounded mb-2 overflow-hidden" *ngIf="finished">
      <div class="channel-header">
        <div class="channel-image-header overflow-hidden text-center bg-very-light-grey-color">
          <img src={{drugDetail?.logo}} class="post-pic w-100" height="200px"
            onerror="this.src='assets/img/image_placeholder.svg'" />
        </div>
        <div class="channel-heading pl-3 pr-3 clearfix position-relative">
          <div class="pt-2 pb-2 float-left">
            <p class="fnt-size18px font-weight-bold">{{drugDetail?.name}}<span *ngIf="drugDetail?.drug_strength!=''"> -
                {{drugDetail?.drug_strength}}</span><span *ngIf="drugDetail?.medicine_type!=''"> -
                {{drugDetail?.medicine_type}}</span></p>
          </div>
        </div>
        <div class=" pl-3 pr-3 clearfix position-relative">
          <span class="clinical-compny position-relative mr-3 text-medium-grey fnt-size12px">
            <img class="mr-1 rounded-circle post-pic" src={{drugDetail?.pharma_logo}}
              onerror="this.src='assets/img/image_placeholder.svg'" />{{drugDetail?.pharma_name}}</span>
          <!-- {{drugDetail | json}} -->
          <!-- <button class="float-right btn btn-success mb-2 fnt-size14px pt-1 pb-1" *ngIf=" drugDetail?.order_allow?.order_button_flag==1" [eventTracker]='{"category":mls.googleEventText.drug_sample_detail.category,"action":mls.googleEventText.drug_sample_detail.key1,"product_type":"15", "product_id":drugDetail.drug_id}' (click)="showDrugForm(drugDetail?.drug_id  )"  >Order Now</button> -->
        </div>
        <div class="channel-content p-3 border-top mt-2">
          <div [innerHtml]="drugDetail?.description"></div>
          <!-- <app-content-card [cmt]="drugDetail?.description" [showChar]="350"></app-content-card> -->
        </div>
        <!-- <div *ngIf="drugDetail?.composition !=''" class="channel-content p-3 border-top">
            <p class="text-very-dark-grey mb-2 font-weight-bold">Composition</p>
            <span *ngFor='let composition of drugDetail?.composition'>
                  <p class="fnt-weight500"> {{composition?.composition_name}}</p>
                  <div class="mb-2"> 
                      <div [innerHtml]="composition?.composition_description"></div>
                  </div>                      
          </span>
        </div> -->
      </div>
    </div>



    <div class='text-center'>
      <img *ngIf="!finished " class="text-center" src="./assets/images/loader-small.svg" width="40" height="100"
        id="loadmore_post">
    </div>



  </div>

</div>